import React from "react";

export default (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="900" height="600">
    <rect fill="#ed2939" width="100%" height="100%" />
    <rect fill="#fff" y="33.3%" width="100%" height="33.3%" />
  </svg>
);
